import { render, staticRenderFns } from "./vcAddPerson.vue?vue&type=template&id=dfdd19d4&"
import script from "./vcAddPerson.vue?vue&type=script&lang=js&"
export * from "./vcAddPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports